import React, { useCallback, useEffect, useState, useRef } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useMediaQuery } from 'react-responsive'

import { useAppDispatch, useAppSelector } from "../../hooks";
import { fetchDocument, signDocs } from "../../actions/ite";
import { DOCUMENT_VIEW_SUCCESS } from "../../actions/view";
import styles from "../../styles/View/View.module.css";
import { SignPopup } from "../Popup/SignPopup";
import Infobar from "../View/Infobar";
import { DIIA_RESET, signDocs as diiaSign } from "../../actions/diia";
import { SIGN_RESET } from "../../actions/sign";
import { DiiaSignPopup } from "../Popup/DiiaSignPopup";
import { FileSignPopup } from "../Popup/FileSignPopup";
import { BtnWrapper } from "../../styles/Docs/DocsToolbar.styled";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";

import ScaleSlider from "../ScaleSlider";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Tooltip from "@mui/material/Tooltip";
// import MoreInfo from "../View/MoreInfo";
import DocsToolbarDevice from "../Docs/DocsToolbarDevice";
import { SkeletonInfobar,SkeletonOneLine } from "../Loaders/SkeletonLoader";
import PdfViewer from "../View/PdfViewer";
import { useContainerDimensions } from "../../hooks";
import DownloadButton from "../DownloadButton";
import { StatusDocInfo } from "../View/Infobar";

export default function View() {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const diia = useAppSelector((state) => state.diia);
  const doc = useAppSelector((state) => state.view);
  const sign = useAppSelector((state) => state.sign);
  const [showPopup, setShowPopup] = useState(false);
  const [showFilePopup, setShowFilePopup] = useState(false);
  const [showDiiaPopup, setShowDiiaPopup] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [scale, setScale] = useState(95);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const user = useAppSelector((state) => state.user);
  const componentRef = useRef();
  const { width } = useContainerDimensions(componentRef);
  const signed = doc.signatures?.filter((el) => !el.stamp).length > 0 && (
    doc.signatures?.filter((el) => el.stamp).length > 0 || !user?.company?.stamp
  );

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setScale(newValue);
  };

  const signMethods = !signed && doc.methods
    ? doc.methods.reduce((memo, method) => {
        memo[method.alias] = true;
        return memo;
    }, {})
    : {};

  const clickCloseButton = useCallback(() => {
    setShowDetails(false);
  }, [showDetails]);
    
  const clickBackButton = useCallback(
    (e) => {
      e.preventDefault();
      if (showDetails) {
        setShowDetails(false);
      } else {
        navigate(-1);
      }
    },
    [showDetails],
  );

  const closePopup = useCallback(() => {
    setShowPopup(false);
  });

  const closeDiiaPopup = useCallback(() => {
    dispatch({ type: DIIA_RESET });
    setShowDiiaPopup(false);
  });

  const closeFilePopup = useCallback(() => {
    setShowFilePopup(false);
  });

  const clickSignButton = useCallback((e) => {
    e.preventDefault();
      dispatch({ type: SIGN_RESET });
    setShowPopup(true);
  }, [sign]);

  const clickDiiaSignButton = useCallback((e) => {
    e.preventDefault();
      dispatch({ type: SIGN_RESET });
    dispatch(diiaSign([params.id], "ite", token));
    setShowDiiaPopup(true);
  }, [params.id, token]);

  const clickFileSignButton = useCallback((e) => {
    e.preventDefault();
      dispatch({ type: SIGN_RESET });
    setShowFilePopup(true);
  }, []);

  const submitForm = useCallback((key) => {
    dispatch(signDocs([params.id], key, token, false));
  }, [params.id, token]);

  const isDesktop = useMediaQuery({ minWidth: 992 })
  const isMobile = useMediaQuery({ maxWidth: 991 })

  useEffect(() => {
    dispatch(fetchDocument(params.id, token));
  }, [params.id, token, sign.state]);

  useEffect(() => {
    if (sign.state === "success") {
      dispatch({ type: SIGN_RESET });
      const result = sign.list.reduce((memo, el) => {
        memo[el.id] = { ...el };
        return memo;
      }, {});
      dispatch({
        type: DOCUMENT_VIEW_SUCCESS,
        payload: result[params.id],
      });
      setShowFilePopup(false);
      setShowPopup(false);
      closeDiiaPopup();
    }
  }, [params.id, sign]);

  return (
    <>
        <section className={isMobile ? styles.boxmobile : styles.wrapperIte}>
          {isMobile && showDetails && (
            <Infobar
              doc={doc}
              clickCloseButton={clickCloseButton}
              sign={sign}
              heightBar={Object.keys(signMethods).length}
            />
          )}
          {!showDetails &&
            <div className={styles.left}> 
              <div className={styles.toolsLine}>
                <Tooltip title="Назад">
                  <BtnWrapper $bgColor="var(--black)" onClick={clickBackButton}>
                    <ArrowBackIosNewIcon sx={{color: "var(--white)", fontSize: 16}}/>
                  </BtnWrapper>
                </Tooltip>
                {doc.state === "success" && (
                  <>
                    <ZoomInMapIcon />
                    <ScaleSlider
                      size={isMobile ? "small" : "normal"}
                      zoomIcon= {!isMobile}
                      max={isMobile ? 200 : 100}
                      scale={scale}
                      handleSliderChange={handleSliderChange}
                    />
                    <DownloadButton
                      selectedDocs={doc.cancelled ? '' :[doc.id]}
                      token={token}
                      type="ite"
                      doc={doc}
                    />
                  </>
                )}
                {isMobile && (
                  <BtnWrapper $bgColor="var(--black)">
                    <MoreVertIcon
                      sx={{ color: "white" }}
                      onClick={() => setShowDetails(true)}
                    />
                  </BtnWrapper>
                )}
              </div>
              { isMobile ? ( 
                <div className={styles.blockStatus}>
                  {doc.state === "loading" ? (
                    <SkeletonOneLine/>
                  ) : ( 
                  <>
                    <div>{StatusDocInfo(doc)}</div>
                    {!!doc.comment && <p>{doc.comment}</p>}
                    {doc.error && (doc.error.code === 115 ? null : <p>{doc.error.message}</p>)}
                  </>
                  )}
                </div>
              ) : null }
              <div 
              className={
                Object.keys(signMethods).length === 0 ? styles.pdf : (
                  Object.keys(signMethods).length < 3 && !doc.error ? `${styles.pdf} ${styles.pdf_m}` : `${styles.pdf} ${styles.pdf_s}`
                  )} 
                ref={componentRef}>
                  <PdfViewer url={doc.url} width={width} scale={scale} />
              </div>
            </div>
          }
          {isDesktop &&
            <div className={styles.right}>
              {doc.state === "loading" ? (
                <SkeletonInfobar />
                ) : (
                <>
                  <Infobar
                    doc={doc}
                    sign={sign}
                  />
                  {!signed && (
                    <DocsToolbarDevice
                      clickSignButton={
                        signMethods.gryada ? clickSignButton : null
                      }
                      clickDiiaSignButton={
                        signMethods.diia ? clickDiiaSignButton : null
                      }
                      clickFileSignButton={
                        signMethods.file ? clickFileSignButton : null
                      }
                      signMethods={signMethods}
                      sign={sign}
                      doc={doc}
                    />
                  )}
                </>
              )}
            </div>
          }
        </section>
        {isMobile && doc.state !== "loading" &&
          <DocsToolbarDevice
            hideDownloadFilesBtn = {true}
            showDetails={showDetails}
            clickSignButton={
              signMethods.gryada ? clickSignButton : null
            }
            clickDiiaSignButton={
              signMethods.diia ? clickDiiaSignButton : null
            }
            clickFileSignButton={
              signMethods.file ? clickFileSignButton : null
            }
            signMethods={signMethods}
            sign={sign}
            doc={doc}
            sys={true}
          />  
        }

        {showPopup ? (
        <SignPopup
          clickCloseButton={closePopup}
          onSubmit={submitForm}
          sign={sign}
        />
      ) : null}
      {showDiiaPopup ? (
        <DiiaSignPopup clickCloseButton={closeDiiaPopup} diia={diia} />
      ) : null}
      {showFilePopup ? (
        <FileSignPopup
          clickCloseButton={closeFilePopup}
          onSubmit={submitForm}
          sign={sign}
        />
      ) : null}
    </>
  );
}
